import { render, staticRenderFns } from "./BtnExpand.vue?vue&type=template&id=70bce23a&scoped=true&lang=pug&"
import script from "./BtnExpand.vue?vue&type=script&lang=js&"
export * from "./BtnExpand.vue?vue&type=script&lang=js&"
import style0 from "./BtnExpand.vue?vue&type=style&index=0&id=70bce23a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bce23a",
  null
  
)

export default component.exports